import React, { useEffect, useState } from 'react';
import { route } from '../../../../services/utils';
import { useParams } from 'react-router';
import { LIVESTOCK_ANIMALS_AND_EVENTS_INDEX } from '../../../../router/routes';
import { useService } from '../../../../services/services';

import { useTranslation } from 'react-i18next';
import AnimalsAndEventsTabKeys from '../enums/animals-and-events-tab-keys';
import css from './view.module.css';
import TabsKeys from '../enums/animal-tab-keys';
import { faLongArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { LinkComponent } from '../../../../components/form/elements/link';
import {
  Tab,
  TabContainer,
  TabContents,
  TabLink,
  TabNavigation,
} from '../../../../components/common/tabs/tab-container';
import AnimalNotes from './animal-notes';
import AnimalInformation from './animal-information';
import Spinner from '../../../../components/common/spinner';
import cn from 'classnames';
import AnimalListCreateButtons from './components/create-buttons/animal-list-create-buttons';
import AnimalEvents from './animal-events';
import ShowIfAllowed from '../../../../components/common/show-if-allowed';
import Animal from '../../../../interfaces/animal';

export default function AnimalView() {
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const [currentTab, setTab] = useState(TabsKeys['information']);
  const { animalService } = useService();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const transKeyPrefix = 'pages.livestock.animals_and_events.animals';
  const [animal, setAnimal] = useState<Animal>(null);
  useEffect(() => {
    setLoading(true);
    animalService.syncShow(farmId, id).subscribe(
      () => {
        setLoading(false);
      },
      () => {
        setLoading(false);
      }
    );
  }, [animalService, farmId, id]);
  useEffect(() => {
    if (!loading) {
      animalService.show(farmId, id).subscribe((res) => {
        setAnimal(res);
      });
    }
  }, [loading, animalService, farmId, id]);

  const formTitle =
    animal?.animal_id && animal?.name
      ? `${animal?.animal_id}, ${animal?.name}`
      : '';

  return (
    <div
      className={cn(css['field-info'], {
        'animal-info': currentTab === TabsKeys.information,
      })}
    >
      <div className={css['header']}>
        <LinkComponent
          label="back"
          icon={faLongArrowLeft}
          linkTo={route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
            farmId,
            tab: AnimalsAndEventsTabKeys.animals,
          })}
        />
        <h2>{formTitle}</h2>
      </div>
      {loading ? (
        <div className={css['loading']}>
          <div>{t('Loading')}</div>
          <Spinner visible={true} size="lg" />
        </div>
      ) : (
        <>
          <ShowIfAllowed ability={{ title: 'create animal_event' }}>
            {currentTab !== TabsKeys.events && !(animal?.exclusion_date ?? null) && !(animal?.moved ?? true) && (
              <div className={css['toolbar']}>
                <AnimalListCreateButtons farmId={farmId} animals={[id]} />
              </div>
            )}
          </ShowIfAllowed>
          <TabContainer
            selectedTabKey={currentTab}
            setTab={setTab}
            tabNavigation={
              <TabNavigation theme={'pages'}>
                <TabLink tabKey={TabsKeys.events} theme={'pages'}>
                  {/* FIXME Style prop value must be an object */}
                  {t(`${transKeyPrefix}.animal-tabs.events`)}
                </TabLink>
                <TabLink tabKey={TabsKeys.productivity} theme={'pages'}>
                  {/* FIXME Style prop value must be an object */}
                  {t(`${transKeyPrefix}.animal-tabs.productivity`)}
                </TabLink>
                <TabLink tabKey={TabsKeys.veterinary} theme={'pages'}>
                  {/* FIXME Style prop value must be an object */}
                  {t(`${transKeyPrefix}.animal-tabs.veterinary`)}
                </TabLink>
                <TabLink tabKey={TabsKeys.information} theme={'pages'}>
                  {/* FIXME Style prop value must be an object */}
                  {t(`${transKeyPrefix}.animal-tabs.basic-info`)}
                </TabLink>
                <TabLink tabKey={TabsKeys.notes} theme={'pages'}>
                  {/* FIXME Style prop value must be an object */}
                  {t(`${transKeyPrefix}.animal-tabs.notes`)}
                </TabLink>
              </TabNavigation>
            }
            tabContents={
              <TabContents theme={'pages'}>
                <Tab tabKey={TabsKeys.events}>
                  <AnimalEvents animal={animal} />
                </Tab>
                <Tab tabKey={TabsKeys.productivity}>{/* view */}</Tab>
                <Tab tabKey={TabsKeys.veterinary}>{/* view */}</Tab>
                <Tab tabKey={TabsKeys.information}>
                  <AnimalInformation animal={animal} />
                </Tab>
                <Tab tabKey={TabsKeys.notes}>
                  <AnimalNotes />
                </Tab>
              </TabContents>
            }
          />
        </>
      )}
    </div>
  );
}
